<template>
  <div class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-md ts-p-3 ts-w-full">
    <label>{{ $t('wholesale.previewOption') }}</label>
    <div class="ts-flex ts-space-x-3">
      <div class="ts-border ts-border-blue-400 ts-rounded ts-p-3 ts-w-full">
        <div>
          <a-radio-group name="radioGroup" v-model="model.currency">
            <a-radio value="USD"> USD </a-radio>
            <a-radio value="KHR"> KHR </a-radio>
            <a-radio value="THB"> THB </a-radio>
          </a-radio-group>
        </div>
        <small>{{ $t('wholesale.currency') }}</small>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'previewOption',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {},
    }
  },
  created() {
    this.model = this.value
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>